const WarningIcon = (props : any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#FF7800"
      d="M15.625 11.688c.104.208.177.416.219.624.062.188.104.376.125.563v.156c0 .646-.24 1.146-.719 1.5-.48.334-1 .5-1.563.5H2.281c-.27 0-.541-.041-.812-.125-.271-.104-.521-.24-.75-.406a2.226 2.226 0 0 1-.531-.625A1.86 1.86 0 0 1 0 13.031v-.156c0-.208.031-.396.094-.563.083-.187.177-.395.281-.624l5.781-10.5C6.656.395 7.292 0 8.063 0c.77 0 1.385.396 1.843 1.188l5.719 10.5ZM8 3.968c-.27 0-.52.084-.75.25-.208.167-.313.438-.313.813.021.146.053.386.094.719.042.292.073.677.094 1.156.042.48.083 1.115.125 1.907 0 .229.073.395.219.5a.937.937 0 0 0 .5.156c.458 0 .708-.219.75-.656l.062-1.126.281-2.656c0-.375-.114-.646-.343-.812A1.118 1.118 0 0 0 8 3.969Zm0 9.345c.417 0 .74-.126.969-.376.25-.25.375-.583.375-1 0-.395-.125-.718-.375-.968-.23-.25-.552-.375-.969-.375-.417 0-.75.125-1 .375-.23.25-.344.573-.344.969 0 .416.115.75.344 1 .25.25.583.374 1 .374Z"
    />
  </svg>
)
export default WarningIcon
